import React, { useState, useEffect, createRef, memo } from 'react';
import PropTypes from 'prop-types';
import { flatten } from 'lodash';
import { get } from 'axios';

import { actionSvgs, callbackSvgs } from 'assets/icons';

import endpoints from 'services/endpoints';

import FilledButton from 'components/Buttons/FilledButton';
import Checkbox from 'components/FormGroup/Checkbox';

import useFetch from 'hooks/useFetch';

import { formatDate, dayOfWeek } from 'utils/moment';
import { FormatCurrency, ArrUniq } from 'utils/core';
import { GeneratePDF } from '../../utils';
import { getStatus } from './utils';

import * as S from './styles';

const GenerateArray = (arr, callback) =>
  Array.from({ length: arr.length }, callback);

const RefundsTable = ({ data, setModalState, setModalData }) => {
  const [arrCheckStates, setArrCheckStates] = useState();
  const [sendObj, setSendObj] = useState([]);
  const { refundsCategoryTypes, refundFiles } = endpoints;

  const [refundsCategories] = useFetch(refundsCategoryTypes);
  const arrEmployees = ArrUniq(data, o => o.nome_funcionario);
  const checkBoxRefs = GenerateArray(data, () => createRef());

  useEffect(() => {
    (async () => {
      const res = await data;

      setArrCheckStates(GenerateArray(res, () => ({ state: false })));
    })();

    return () => {
      setArrCheckStates([]);
      setSendObj([]);
    };
  }, [data]);

  const showMoreInfo = (itens, valor) => {
    const total = itens.map(i => ({ total: i.quantidade * i.valor_unitario }));

    return (
      <S.MoreActionsIncoContainer>
        {FormatCurrency(valor)}
        {!!itens.length && (
          <S.ProjectMore>
            <S.MoreActionsIcon
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 256 256"
            >
              <path
                d=" M -1 128 C -1.01 110.76 2.44 93.69 9.15 77.81 C 15.64 62.48 25.03 48.56 36.8 36.8 C 48.56 25.03 62.48 15.64 77.8 9.15 C 93.69 2.44 110.76 -1.01 128 -1 C 145.24 -1.01 162.31 2.44 178.2 9.15 C 193.52 15.64 207.44 25.03 219.2 36.8 C 230.97 48.56 240.36 62.48 246.85 77.8 C 253.56 93.69 257.01 110.76 257 128 C 257.01 145.24 253.56 162.31 246.85 178.2 C 240.36 193.52 230.97 207.44 219.2 219.2 C 207.44 230.97 193.52 240.36 178.2 246.85 C 162.31 253.56 145.24 257.01 128 257 C 110.76 257.01 93.69 253.56 77.8 246.85 C 62.48 240.36 48.56 230.97 36.8 219.2 C 25.03 207.44 15.64 193.52 9.15 178.2 C 2.44 162.31 -1.01 145.24 -1 128 Z  M 15 128 C 14.99 112.9 18.01 97.95 23.88 84.03 C 29.57 70.62 37.8 58.42 48.11 48.11 C 58.42 37.8 70.62 29.57 84.04 23.88 C 97.95 18.01 112.9 14.99 128 15 C 143.1 14.99 158.05 18.01 171.96 23.88 C 185.38 29.57 197.58 37.8 207.89 48.11 C 218.2 58.42 226.43 70.62 232.12 84.04 C 237.99 97.95 241.01 112.9 241 128 C 241.01 143.1 237.99 158.05 232.12 171.96 C 226.43 185.38 218.2 197.58 207.89 207.89 C 197.58 218.2 185.38 226.43 171.96 232.12 C 158.05 237.99 143.1 241.01 128 241 C 112.9 241.01 97.95 237.99 84.04 232.12 C 70.62 226.43 58.42 218.2 48.11 207.89 C 37.8 197.58 29.57 185.38 23.88 171.96 C 18.01 158.05 14.99 143.1 15 128 Z  M 115.5 118.625 L 140.5 118.625 L 140.5 187.377 L 115.5 187.377 L 115.5 118.625 Z  M 112.374 84.249 C 112.374 75.625 119.376 68.623 128 68.623 C 136.624 68.623 143.626 75.625 143.626 84.249 C 143.626 92.873 136.624 99.874 128 99.874 C 119.376 99.874 112.374 92.873 112.374 84.249 Z "
                fillRule="evenodd"
              />
            </S.MoreActionsIcon>
            <S.MoreActions>
              <S.MoreActionsHeader>Mais informações</S.MoreActionsHeader>
              {refundsCategories && (
                <S.MoreActionsTable>
                  <S.MoreActionsTableHeader>
                    <div>Categoria</div>
                    <div>Qtd.</div>
                    <div>Valor Unit.</div>
                    <div>Total</div>
                  </S.MoreActionsTableHeader>
                  {itens.map((item, k) => {
                    const category = refundsCategories.find(
                      c => c.value === item.id_tipo_reembolso,
                    );
                    return (
                      category && (
                        <S.MoreActionsInfo key={item.id_item_reembolso}>
                          <S.InfoStrong>{category.label}</S.InfoStrong>
                          <S.InfoSpan>{item.quantidade}</S.InfoSpan>
                          <S.InfoSpan>
                            {FormatCurrency(item.valor_unitario)}
                          </S.InfoSpan>
                          <S.InfoSpan>
                            {FormatCurrency(total[k].total)}
                          </S.InfoSpan>
                        </S.MoreActionsInfo>
                      )
                    );
                  })}
                </S.MoreActionsTable>
              )}
            </S.MoreActions>
          </S.ProjectMore>
        )}
      </S.MoreActionsIncoContainer>
    );
  };

  // const handleCheckAll = async (isCheck) => {
  //  await setArrCheckStates(states => {
  //     const arrStates = states.map(() => ({ state: isCheck }));
  //     return [...arrStates];
  //   });
  //   const checkElmts = checkBoxRefs.map(el => el.current);

  //   const prevCheckedStates = checkElmts.filter(el => el && el.checked);
  //   const prevElValues = prevCheckedStates && prevCheckedStates.length ? prevCheckedStates.map(el => JSON.parse(el.value)) : {};
  //   console.log(checkElmts)
  //   const callback = prev => {
  //     if (isCheck) {
  //       return [...data];
  //     }
  //     if (prevElValues.length) {
  //       if (prevElValues.length === prev.length) {
  //         setArrCheckStates(states => {
  //           const arrStates = states.map(() => ({ state: false }));
  //           return [...arrStates];
  //         });
  //         return [];
  //       }
  //     }
  //   };

  //   setSendObj(callback);
  // };

  const handleCheckEach = index => e => {
    e.persist();
    const { checked, value } = e.target;
    const obj = JSON.parse(value);
    setArrCheckStates(prev => {
      const previous = prev;
      previous[index].state = checked;
      return [...prev];
    });

    const callback = prev => {
      if (checked) {
        return prev ? [...prev, { ...obj }] : [{ ...obj }];
      }

      return prev.filter(item => item.id_reembolso !== obj.id_reembolso);
    };
    setSendObj(callback);
  };

  const exportPDF = async dataPdf => {
    const allRefunds = await dataPdf.map(item => item.id_reembolso);
    const getFiles = await get(`${refundFiles}/${allRefunds.join(',')}`);
    const { data: res } = await getFiles;
    const flatArr = flatten(dataPdf.map(i => i.itens));
    const dt_pdf = flatArr.map(it => {
      const filter = dataPdf.filter(item => item.itens.includes(it));
      return { ...filter[0], ...it };
    });
    const generalInfo = dataPdf[0];
    const rows = dt_pdf;
    const pdfData = { ...generalInfo, rows, files: res.input };
    const result = await GeneratePDF(pdfData);
    return result;
  };

  return (
    <S.Table>
      <div className="table-responsive">
        {!data.length ? (
          <S.Callback>
            {callbackSvgs('circularMan')}
            <S.CallbackText>
              Não existem solicitações de reembolso neste mês
            </S.CallbackText>
          </S.Callback>
        ) : (
          <table className="table">
            <thead>
              <tr>
                {arrEmployees.length === 1 && (
                  <th scope="col">
                    {/*                     <Checkbox
                      filled
                      id="selectAll"
                      name="selectAll"
                      onChange={async (e) => {
                        const { checked } = e.target;
                        await setAllCheck(prev => !prev);
                        await handleCheckAll(checked);
                      }}
                      checked={allCheck}
                    /> */}
                  </th>
                )}
                <th scope="col">Data</th>
                <th scope="col">Funcionário</th>
                <th scope="col">Projeto</th>
                <th scope="col">Valor reembolso</th>
                <th scope="col">Status</th>
                <th scope="col"> </th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={row.id_reembolso}>
                  {arrEmployees.length === 1 && !!arrCheckStates.length && (
                    <td>
                      {(row.id_aprovacao_gestor === 1 ||
                        row.id_aprovacao_gestor === 4) && (
                        <Checkbox
                          ref={checkBoxRefs[index]}
                          onChange={handleCheckEach(index)}
                          id={`check-${index}`}
                          name={`check-${index}`}
                          value={JSON.stringify(row)}
                          // eslint-disable-next-line no-mixed-operators
                          checked={
                            arrCheckStates[index] && arrCheckStates[index].state
                          }
                        />
                      )}
                    </td>
                  )}
                  <td>
                    {formatDate(row.dt_apontamento)}{' '}
                    <span>{`(${dayOfWeek(row.dt_apontamento)})`}</span>
                  </td>
                  <td>{row.nome_funcionario}</td>
                  <td>{`${row.nome_projeto} | ${row.idetificacao_projeto}`}</td>
                  <td>
                    {row.itens && showMoreInfo(row.itens, row.valor_total)}
                  </td>
                  <td
                    className={`status-${getStatus(
                      row.id_aprovacao_gestor,
                      'status',
                    )}`}
                  >
                    {row.descricao_status_aprovacao_gestor}
                  </td>
                  <td>
                    <S.ActionButton
                      type="button"
                      onClick={() => {
                        setModalState(true);
                        setModalData({ ...row });
                      }}
                    >
                      {actionSvgs('newWindow')}
                    </S.ActionButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {sendObj && !!sendObj.length && (
          <div
            style={{
              display: 'flex',
              width: '100%',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <FilledButton
              text="Exportar planilha"
              handleClick={() => exportPDF(sendObj)}
            />
          </div>
        )}
      </div>
    </S.Table>
  );
};

RefundsTable.defaultProps = {
  data: [],
  setModalState: () => {},
  setModalData: () => {},
};

RefundsTable.propTypes = {
  data: PropTypes.shape(
    PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.number]),
  ),
  setModalState: PropTypes.func,
  setModalData: PropTypes.func,
};

export default memo(RefundsTable);
